<template>
  <div>
    <div class="addition-content-plan"
         style="margin-top: 10px">
      <!-- 产品附加项列表 -->

      <el-table :data="spu_addition_data_list"
                stripe
                style="width: 100%"
                @selection-change="handleSelectionChange">
        <el-table-column prop="addition_id"
                         label="ID"
                         width="40">
        </el-table-column>
        <el-table-column type="selection"
                         width="55"> </el-table-column>
        <el-table-column prop="addition_name"
                         label="产品附加项"
                         width="100%">
        </el-table-column>
        <el-table-column prop="addition_price"
                         label="附加项售价/元"
                         width="120%"></el-table-column>
        <el-table-column prop="addition_net_price"
                         label="底价"
                         width="100%">
          <template slot-scope="price">
            <div>{{(price.row.addition_net_price/100).toFixed(2)}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="addition_info"
                         label="说明"></el-table-column>
        <el-table-column prop="sell_out"
                         align="center"
                         label="操作"
                         width="auto">
          <template slot-scope="addition_data_list">
            <el-switch @change="changeSellStatus"
                       v-model="addition_data_list.row.sell_out"
                       active-color="#13ce66"
                       inactive-color="#ff4949"
                       active-text="可订"
                       inactive-text="不可订"
                       :active-value="active_value"
                       :inactive-value="inactive_value"></el-switch>
            ｜
            <el-link :underline="false"
                     @click="deleteAdditionSpu(addition_data_list.row)">删除附加项</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!------------------------------ 列表结束 ------------------------------>
    <!-- 添加附加项对话框 -->
    <el-dialog title="添加产品可选的附加项"
               :visible.sync="additionFormVisible"
               width="800px">
      <el-form ref="additionDialog"
               :model="addition_items"
               :inline="false">
        <!-- 附加项：名称 prop 在使用 validate、resetFields 方法的情况下，该属性是必填的-->
        <el-form-item label="可选附加项名称"
                      :label-width="formLabelWidth"
                      prop="addition_name">
          <el-input class="addition_input"
                    size="mini"
                    v-model="addition_items.addition_name"
                    autocomplete="off"></el-input>
        </el-form-item>
        <!-- 附加项：价格 -->
        <el-form-item label="售价"
                      :label-width="formLabelWidth"
                      prop="addition_price">
          <el-input class="addition_input"
                    size="mini"
                    v-model.number="addition_items.addition_price"
                    autocomplete="off"></el-input>
        </el-form-item>
        <!-- 附加项：底价 -->
        <el-form-item label="底价"
                      :label-width="formLabelWidth"
                      prop="addition_net_price">
          <el-input class="addition_input"
                    size="mini"
                    v-model.number="addition_items.addition_net_price"
                    autocomplete="off">
            <!-- 底价：币种   slot="prepend" 在前面插入-->
            <el-select style="width: 100px"
                       v-model="num"
                       slot="prepend">
              <el-option v-for="item in currency_options"
                         :key="item.num"
                         :label="item.name"
                         :value="item.num"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <!-- 附加项：币种 -->
        <!-- <el-form-item label="币种" :label-width="formLabelWidth">
            <el-input
              class="addition_input"
              size="mini"
              v-model="addition_items.net_price_currency"
              autocomplete="off"
            ></el-input>
        </el-form-item>-->
        <!-- 附加项：有无库存 -->
        <el-form-item label="库存"
                      :label-width="formLabelWidth"
                      prop="sell_out">
          <el-radio-group v-model="addition_items.sell_out">
            <el-radio label="1">库存充足</el-radio>
            <el-radio label="0">暂无库存</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 附加项：说明 -->
        <el-form-item label="说明"
                      :label-width="formLabelWidth"
                      prop="addition_info">
          <el-input resize="none"
                    rows="5"
                    type="textarea"
                    class="addition_input_textara"
                    size="mini"
                    v-model="addition_items.addition_info"
                    autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="mini"
                   @click="cancelAdditionForm('additionDialog')">取 消</el-button>
        <el-button size="mini"
                   type="primary"
                   @click="confirmAdditionAdd">添 加</el-button>
      </div>
    </el-dialog>
    <!-- 表单结束 -->
  </div>
</template>

<script>
export default {
  name: 'addition-list-setting',
  data() {
    return {
      sku_id: '',
      spu_id: '',
      spu_addition_data_list: this.spuAdditionDataList, // 产品所包含的附加项列表
      active_value: false, // 可定
      inactive_value: true, // 不可定
      //   添加附加项
      additionFormVisible: false, // 是否打开对话框
      formLabelWidth: '120px', //标题的宽度
      // 表单数据
      addition_items: {
        pass: '',
        addition_name: '',
        addition_price: '',
        addition_net_price: '',
        net_price_currency: '',
        addition_info: '',
        sell_out: '1',
      },
      currency_options: [],
      num: '156',
      //   已选择的附加项
      bandAdditionToSku: [],
    }
  },
  props: {
    spuAdditionDataList: Array,
  },
  watch: {
    spuAdditionDataList(newValue) {
      this.spu_addition_data_list = newValue
    },
  },
  methods: {
    //  删除附加项
    deleteAdditionSpu(addition_id) {
      let addition_data = {
        addition_type: 3,
        addition_id: addition_id.addition_id,
      }

      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http
            .post('/product/deal_with_spu_addition', addition_data)
            .then((res) => {
              if (res.data.errno == '0') {
                this.$notify({
                  title: '成功',
                  message: res.data.errmsg,
                  type: 'success',
                })
                this.$emit('submitAddAddition')
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    //  选定附加项
    handleSelectionChange(value) {
      let addition_id_list = []
      value.forEach((item) => {
        addition_id_list.push(item.addition_id)
      })
      this.bandAdditionToSku = addition_id_list
    },
    // 打开 [添加附加项的]  对话框
    addAdditionDiolag(spu_id) {
      this.spu_id = spu_id
      this.additionFormVisible = true
      this.$http.get('/get_currency').then((res) => {
        this.currency_options = res.data.data
      })
    },
    // 【提交】 添加 附加项 的对话框
    confirmAdditionAdd() {
      let addition_data = {}
      addition_data.addition_type = 1
      addition_data.spu_id = this.spu_id
      // 处理数据
      this.addition_items.addition_price = parseInt(
        this.addition_items.addition_price * 100
      )
      this.addition_items.addition_net_price = parseInt(
        this.addition_items.addition_net_price * 100
      )
      this.addition_items.net_price_currency = this.num
      // 把addition_items 加入到 addition_item的对象中去
      let addition_item = []
      addition_item.push(this.addition_items)
      addition_data.addition_item = addition_item
      //   console.log(addition_data);
      this.$http
        .post('/product/deal_with_spu_addition', addition_data)
        .then((res) => {
          console.log(res)
          const { data, errmsg, errno } = res.data
          if (errno == '0') {
            this.additionFormVisible = false
            this.$notify({
              title: '成功',
              message: errmsg,
              type: 'success',
            })
            // 情空附加项
            let new_addition_items = {
              pass: '',
              addition_name: '',
              addition_price: '',
              addition_net_price: '',
              net_price_currency: '',
              addition_info: '',
              sell_out: '1',
            }
            this.addition_items = new_addition_items
            this.$emit('submitAddAddition')
          } else if (errno == '4001' || errno == '4002' || errno == '4004') {
            this.$notify.error({
              title: '错误',
              message: errmsg,
            })
          }
        })
    },

    // 改变附加项 库存状态 是否有库存/上线
    changeSellStatus() {},
    //  【取消/关闭】 添加附加项的对话框
    cancelAdditionForm(formName) {
      this.$refs[formName].resetFields()
      this.additionFormVisible = false
    },
  },
}
</script>

<style>
.addition-content-plan {
  margin-top: 10px;
  border: 1px solid rgb(221, 221, 221);
}
</style>